var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-inline categories-slider"},_vm._l((_vm.subCategories),function(category){return _c('li',{staticClass:"list-inline-item"},[_c('a',{staticClass:"badge-cat",attrs:{"href":_vm.concatPath(category)}},[_vm._v("\n            "+_vm._s(category.category_name)+"\n        ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }